"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryCollectionModel$ = exports.GeometryCollectionModel$outboundSchema = exports.GeometryCollectionModel$inboundSchema = exports.Geometries$ = exports.Geometries$outboundSchema = exports.Geometries$inboundSchema = void 0;
exports.geometriesToJSON = geometriesToJSON;
exports.geometriesFromJSON = geometriesFromJSON;
exports.geometryCollectionModelToJSON = geometryCollectionModelToJSON;
exports.geometryCollectionModelFromJSON = geometryCollectionModelFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const linestringmodel_js_1 = require("./linestringmodel.js");
const multilinestringmodel_js_1 = require("./multilinestringmodel.js");
const multipointmodel_js_1 = require("./multipointmodel.js");
const multipolygonmodel_js_1 = require("./multipolygonmodel.js");
const pointmodel_js_1 = require("./pointmodel.js");
const polygonmodel_js_1 = require("./polygonmodel.js");
/** @internal */
exports.Geometries$inboundSchema = z.union([
    polygonmodel_js_1.PolygonModel$inboundSchema,
    multipolygonmodel_js_1.MultiPolygonModel$inboundSchema,
    linestringmodel_js_1.LineStringModel$inboundSchema,
    multilinestringmodel_js_1.MultiLineStringModel$inboundSchema,
    pointmodel_js_1.PointModel$inboundSchema,
    multipointmodel_js_1.MultiPointModel$inboundSchema,
]);
/** @internal */
exports.Geometries$outboundSchema = z.union([
    polygonmodel_js_1.PolygonModel$outboundSchema,
    multipolygonmodel_js_1.MultiPolygonModel$outboundSchema,
    linestringmodel_js_1.LineStringModel$outboundSchema,
    multilinestringmodel_js_1.MultiLineStringModel$outboundSchema,
    pointmodel_js_1.PointModel$outboundSchema,
    multipointmodel_js_1.MultiPointModel$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Geometries$;
(function (Geometries$) {
    /** @deprecated use `Geometries$inboundSchema` instead. */
    Geometries$.inboundSchema = exports.Geometries$inboundSchema;
    /** @deprecated use `Geometries$outboundSchema` instead. */
    Geometries$.outboundSchema = exports.Geometries$outboundSchema;
})(Geometries$ || (exports.Geometries$ = Geometries$ = {}));
function geometriesToJSON(geometries) {
    return JSON.stringify(exports.Geometries$outboundSchema.parse(geometries));
}
function geometriesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Geometries$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Geometries' from JSON`);
}
/** @internal */
exports.GeometryCollectionModel$inboundSchema = z.object({
    geometries: z.array(z.union([
        polygonmodel_js_1.PolygonModel$inboundSchema,
        multipolygonmodel_js_1.MultiPolygonModel$inboundSchema,
        linestringmodel_js_1.LineStringModel$inboundSchema,
        multilinestringmodel_js_1.MultiLineStringModel$inboundSchema,
        pointmodel_js_1.PointModel$inboundSchema,
        multipointmodel_js_1.MultiPointModel$inboundSchema,
    ])),
    type: z.literal("GeometryCollection").default("GeometryCollection")
        .optional(),
});
/** @internal */
exports.GeometryCollectionModel$outboundSchema = z.object({
    geometries: z.array(z.union([
        polygonmodel_js_1.PolygonModel$outboundSchema,
        multipolygonmodel_js_1.MultiPolygonModel$outboundSchema,
        linestringmodel_js_1.LineStringModel$outboundSchema,
        multilinestringmodel_js_1.MultiLineStringModel$outboundSchema,
        pointmodel_js_1.PointModel$outboundSchema,
        multipointmodel_js_1.MultiPointModel$outboundSchema,
    ])),
    type: z.literal("GeometryCollection").default("GeometryCollection"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GeometryCollectionModel$;
(function (GeometryCollectionModel$) {
    /** @deprecated use `GeometryCollectionModel$inboundSchema` instead. */
    GeometryCollectionModel$.inboundSchema = exports.GeometryCollectionModel$inboundSchema;
    /** @deprecated use `GeometryCollectionModel$outboundSchema` instead. */
    GeometryCollectionModel$.outboundSchema = exports.GeometryCollectionModel$outboundSchema;
})(GeometryCollectionModel$ || (exports.GeometryCollectionModel$ = GeometryCollectionModel$ = {}));
function geometryCollectionModelToJSON(geometryCollectionModel) {
    return JSON.stringify(exports.GeometryCollectionModel$outboundSchema.parse(geometryCollectionModel));
}
function geometryCollectionModelFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GeometryCollectionModel$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GeometryCollectionModel' from JSON`);
}
//# sourceMappingURL=geometrycollectionmodel.js.map